import { render, staticRenderFns } from "./interest-charges-dialog.vue?vue&type=template&id=5a35947c"
import script from "./interest-charges-dialog.vue?vue&type=script&lang=js"
export * from "./interest-charges-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports